var render, staticRenderFns
import script from "./config-base.vue?vue&type=script&lang=js"
export * from "./config-base.vue?vue&type=script&lang=js"
import style0 from "./config-base.vue?vue&type=style&index=0&id=7d57f933&prod&lang=scss"
import style1 from "./config-base.vue?vue&type=style&index=1&id=7d57f933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57f933",
  null
  
)

export default component.exports